import React from 'react';
import styled, { keyframes } from 'styled-components';
import w1 from '../Assets/bg/w2.jpg'; 
import w2 from '../Assets/bg/w2.jpg';

const Workshops = () => {
  return (
    <Wrapper>
      <Header>
        <TitleP>Workshop and Training</TitleP>
        <IntroText>
          At DISA, we believe in empowering farmers and agricultural stakeholders through hands-on workshops and training sessions. These workshops are designed to teach advanced irrigation techniques, digital tools for water management, and best practices to optimize water use and improve crop yields.
        </IntroText>
      </Header>

      <Card>
        <Title>Upcoming Workshops</Title>

        <Subtitle>Workshop Sessions</Subtitle>
        <List>
          <ListItem>
            <strong>Efficient Water Management for Smallholder Farms</strong><br/>
            <span>Date: April 25, 2025 | Location: Region 1</span><br/>
            A comprehensive workshop focused on water management techniques for smallholder farms. Learn how to optimize irrigation systems using digital tools and improve crop yield.
          </ListItem>
          <ListItem>
            <strong>Advanced Digital Irrigation Technologies</strong><br/>
            <span>Date: May 10, 2025 | Location: Tagbilaran City</span><br/>
            This workshop will cover the latest advancements in digital irrigation technologies. Participants will gain hands-on experience in utilizing IoT devices and data analytics for irrigation systems.
          </ListItem>
        </List>
      </Card>

      <Card>
        <Title>Past Workshops and Success Stories</Title>
        <IntroText>
          Our past workshops have helped hundreds of farmers and irrigation professionals improve their water management practices. Here are some highlights:
        </IntroText>
        <ImageWrapper>
          <WorkshopImage src={w1} alt="Workshop 1" />
          <WorkshopImage src={w2} alt="Workshop 2" />
        </ImageWrapper>
        <IntroText>
          "The training was very helpful. I learned new techniques for managing my irrigation system, which has already resulted in better crop yields and more efficient water usage!" — Participant, Workshop in 2024
        </IntroText>
      </Card>
    </Wrapper>
  );
};

export default Workshops;

// Styled Components

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Wrapper = styled.div`
  padding: 60px 20px;
  background: linear-gradient(to bottom right, #e0f7f4, #ffffff);
  min-height: 100vh;
  font-family: 'Segoe UI', sans-serif;
`;

const Header = styled.div`
  max-width: 1000px;
  margin: 0 auto 40px;
  text-align: center;
`;

const TitleP = styled.h1`
  font-size: 42px;
  font-weight: bold;
  color: #228B22;
  animation: ${fadeIn} 1s ease-in-out;
`;

const IntroText = styled.p`
  font-size: 18px;
  color: #444;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto 30px;
  animation: ${fadeIn} 1.2s ease-in-out;
`;

const Card = styled.section`
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  max-width: 1000px;
  margin: 0 auto 30px;
  animation: ${fadeIn} 1.4s ease-in-out;
`;

const Title = styled.h2`
  font-size: 30px;
  font-weight: 600;
  color: #222;
  margin-bottom: 30px;
`;

const Subtitle = styled.h3`
  font-size: 22px;
  font-weight: 600;
  color: #228B22;
  margin-top: 25px;
  margin-bottom: 15px;
`;

const List = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-top: 10px;
`;

const ListItem = styled.li`
  font-size: 16px;
  color: #333;
  line-height: 1.7;
  margin-bottom: 16px;
  background-color: #f4fdfb;
  border-left: 6px solid #0228B22;
  border-radius: 8px;
  padding: 12px 18px;

  strong {
    color: #228B22;
    font-weight: bold;
  }

  &:hover {
    background-color: #e6faf7;
  }

  span {
    display: block;
    color: #666;
    font-size: 15px;
    margin: 4px 0;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  justify-content: center;
  flex-wrap: wrap;
`;

const WorkshopImage = styled.img`
  width: 45%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;
